module.exports = __webpack_public_path__ + "assets/img/order-count-icon4.f23a02ce.png";